export const mapPositionsToReps = (repStanceData, repData) =>
    repData.map(r => {
        const voteSmartData = repStanceData.find(
            v => v.candidateId === r.voteSmartCandidateId
        );

        return {
            ...r,
            ...voteSmartData
        };
    });
